import { gql } from "apollo-angular";

export const GET_VEHICLE_FUNCTIONS_QUERY = gql`query fileHandlerEeseGetDownloadPresignedUrl($EeseResultFor: EesePollResult) {
    fileHandlerEeseGetDownloadPresignedUrl(EeseResultFor: $EeseResultFor)
  }
  `
